var Vendd = (function (Vendd) {
    'use strict';

    var state = {
        id: LhApp.Context.Item.Id,
        path: LhApp.Context.Item.Path
    };

    var getStoresForm = function (data) {
            var request = {};

            request = _.extend(state, data);

            var options = {
                url: 'StoresService.svc/GetStoresForm',
                data: request,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess (response) {
                var model = response;
                state = _.extend(state, data);

                Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.UpdateForm(model));
            };

            function onFailure (response) {
                console.log(response);
            };

            Vendd.Service.call(options);
        };

    var getStores = function (data) {
            var request = {};

            request = _.extend(state, data);

            var options = {
                url: 'StoresService.svc/GetStores',
                data: request,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess (response) {
                var model = response;

                Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.UpdateStores(model));
            };

            function onFailure (response) {
                console.log(response);
            };

            Vendd.Service.call(options);
        };

    var calculateDistances = function (data) {
    	try {
    		var sourcePoint = data.source.trim();

    		if (sourcePoint.length === 5 && parseInt(sourcePoint) > 9999) {
    			sourcePoint = "greece+" + sourcePoint;
    		} else if (sourcePoint.length === 0) {
    			sourcePoint = "athens";
    		}

    		var origin = sourcePoint;
    		var destinations = [];
    		for (var i = 0; i < data.array.length; i++) {
    			var elem = data.array[i];
    			destinations[i] = new google.maps.LatLng(parseFloat(elem.Latitude.trim()), parseFloat(elem.Longitude.trim()));
    		}

    		var service = new google.maps.DistanceMatrixService();
    		service.getDistanceMatrix(
			  {
			  	origins: [origin],
			  	destinations: destinations,
			  	travelMode: 'DRIVING',
			  	unitSystem: google.maps.UnitSystem.METRIC
			  }, onSuccess);
    	} catch (ex) {
    		Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.CalculateDistancesSuccess(data));
    		console.log(ex);
    	}
    	function onSuccess(response, status) {
    		var model = response;
    		Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.CalculateDistancesSuccess(model));
    	};

    };

    Vendd.Store.Controller = (function () {
            var initialized = false;

            return {
                initState: function (initialState) {
                    if (initialized === true) {

                        return state;
                    } else {

                        state = _.extend(state, initialState);

                        initialized = true;

                        return state;
                    };
                },
                getState: function () {
                    return state;
                }
            };
        })();

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetContinent, Vendd.Store, function (envelope) {
            var data = {
                continent:envelope.message.data.continent,
                country:"",
                city: "",
                area: "",
                type: 0
            };

            getStoresForm(data);
        });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetCountry, Vendd.Store, function (envelope) {
            var data = {
                country: envelope.message.data.country,
                city: "",
                area: "",
                type: 0
            };

            getStoresForm(data);
        });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetCity, Vendd.Store, function (envelope) {
            var data = {
                city: envelope.message.data.city,
                area: "",
                type: 0
            };

            getStoresForm(data);
        });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetArea, Vendd.Store, function (envelope) {
            var data = {
                area: envelope.message.data.area,
                type: 0
            };

            getStoresForm(data);
        });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetType, Vendd.Store, function (envelope) {
            var data = {
                type: envelope.message.data.type
            };

            getStoresForm(data);
        });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.Refine, Vendd.Store, function (envelope) {
            getStores(envelope.message.data.state);
        });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.CalculateDistances, Vendd.Store, function (envelope) {
    	calculateDistances(envelope.message.data);
    });

    return Vendd;

})(Vendd || {});